import myAxios from '../myAxios'
import { apiUrl_ } from '../config'
import { FlutterwaveMetadataInterface } from '../../components/PaymentComponent/PayWithFlutterwave/PayWithFlutterwave'

const myBaseUrl = apiUrl_
const myBaseUsersUrl = `${myBaseUrl}/users/api/v1`

export const CreateFlutterwaveTransactionReference = (
  user_id: string,
  payment_for: string,
  amount: number,
  currency: string,
) => {
  const body = {
    user_id,
    payment_for,
    amount,
    currency,
  }

  return myAxios.post(
    `${myBaseUsersUrl}/flutterwave/transaction_reference`,
    body,
  )
}

export const createFlutterwaveCheckoutSession = (args: {
  currency: string
  title: string
  email: string
  successUrl: string
  amount: number
  metadata: FlutterwaveMetadataInterface
  userName: string
  phoneNumber?: string
  description: string
  logo: string
  payment_plan?: string
}) => {
  const body = {
    currency: args.currency,
    title: args.title,
    email: args.email,
    success_url: args.successUrl,
    amount: args.amount,
    metadata: args.metadata,
    phone_number: args.phoneNumber,
    description: args.description,
    logo: args.logo,
    payment_for: args.metadata.payment_for,
    user_name: args.metadata.user_name,
    user_id: args.metadata.user_id,
    payment_plan: args.payment_plan,
  }
  return myAxios.post(
    `${myBaseUsersUrl}/flutterwave/create-checkout-session`,
    body,
  )
}
